<template>
  <button
    class="jade-icon-button"
    :class="computedClass"
    :aria-label="icon"
    :type="type"
    :disabled="disabled || loading"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <jade-spinner
      v-if="loading"
      color="current-color"
      :size="computedIconSize"
    />
    <jade-icon
      v-else
      color="current-color"
      :use="icon"
      :size="computedIconSize"
    />
  </button>
</template>

<script>
import SIZE_ENUM from '../enums/sizes.enum'
import BUTTON_VARIANTS from '../enums/button-variants.enum'

export default {
  name: 'jade-icon-button',

  components: {
    JadeIcon: () => import('../JadeIcon/index.vue'),
    JadeSpinner: () => import('../JadeSpinner/index.vue')
  },

  props: {
    disabled: Boolean,
    loading: Boolean,
    icon: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'button'
    },
    variant: {
      type: String,
      validation: size => Object.values(BUTTON_VARIANTS).includes(size),
      default: BUTTON_VARIANTS.NEUTRAL_SUBTLE
    },
    size: {
      type: String,
      validation: size =>
        Object.values([
          SIZE_ENUM.LARGE,
          SIZE_ENUM.MEDIUM,
          SIZE_ENUM.SMALL
        ]).includes(size),
      default: SIZE_ENUM.LARGE
    }
  },

  computed: {
    computedIconSize () {
      return this.size === SIZE_ENUM.MEDIUM ? this.size : SIZE_ENUM.LARGE
    },
    computedClass () {
      return {
        [`is-${this.size}`]: this.size,
        [`is-${this.variant}`]: this.variant,
        'is-loading': this.loading
      }
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade/css/icon-button.css';
</style>
